//React Components
import React, { useState, useEffect } from 'react';
import { Col, ListGroup } from 'react-bootstrap';
//Components
import Navbar from '../NavBar/Navbar';
import ModalDetailEvents from './ModalDetailEvents';
import SmartPayForm from '../Modal/Modal';
//Alert
import ErrorAlert from '../Alerts/ErrorAlert';
//API
import { EventsFetchAPI } from '../../api/Events';
//Images
import defaultImage from "../../assets/img/default.png"
//Utils
import { RenderIf } from '../utils/RenderIf';
import { checkUserPermission } from '../utils/CheckUserPermitions';
import { BranchOfficeFetchAPI } from '../../api/BranchOffices';
import { Modal, Button, Form } from 'react-bootstrap';
import EventCalendar from './EventCalendar';
// import Sidebar from '../SideBar/Sidebar';
import { formatDate } from './utils/date';
import { buildCloudinaryImageUrl } from '../utils/CloudinaryImageUrl';
//Modals 
//import SmartpayFormModal from '../Modal/SmartpayFormModal'; 
// Component of the Events
const Events = () => {
    //User 
    let user = JSON.parse(localStorage.getItem('user'));
    let token = localStorage.getItem('x-access-token');
    //States
    const [events, setEvents] = useState([]);
    const [selectedEvent, setSelectedEvent] = useState({});
    const [showNewEventModal, setShowNewEventModal] = useState(false);
    const [showDatesEventModal, setShowDatesEventModal] = useState(false);
    const [selectedBranch, setSelectedBranch] = useState("");
    const [branches, setBranches] = useState([]);
    const [showBranchModal, setShowBranchModal] = useState(false);
    const [branchDefault, setBranchDefault] = useState([]);
    //We set the modal fields 
    const [formData, setFormData] = useState({});
    const [modalFields, setModalFields] = useState([
        { name: 'name', label: 'Nombre', type: 'text', placeholder: 'Ingrese nombre', required: true },
        { name: "public", label: "Publico esperado", type: "number", placeholder: "Ingrese la cantidad de publico esperado", required: true },
        { name: 'description', label: 'Descropcion', type: 'text', placeholder: 'Ingrese descripcion', required: true },
        { name: 'initialDate', label: 'Fecha de inicio', type: 'date', placeholder: 'Fecha de inicio', required: true },
        { name: 'maxDate', label: 'Fecha de fin', type: 'date', placeholder: 'Fecha de fin', required: true }
    ]);
    const [formDataDates, setFormDataDates] = useState([
        { name: 'initialDate', label: 'Fecha de inicio', type: 'date', placeholder: 'Fecha de inicio', required: true },
        { name: 'maxDate', label: 'Fecha de fin', type: 'date', placeholder: 'Fecha de fin', required: true },
        { name: "public", label: "Publico esperado", type: "number", placeholder: "Ingrese la cantidad de publico esperado", required: true },
    ]);


    //Function to detect the change of value on the users forms
    const handleFieldChange = (fieldName, value) => {
        setFormData((prevData) => ({
            ...prevData,
            [fieldName]: value,
        }));
    };

    function isoToJsDate(isoString) {
        const date = new Date(isoString);
        // Recuerda: el mes en new Date(año, mes, día) es base 0 (enero = 0)
        let year = date.getFullYear();
        let month = date.getMonth();
        let day = date.getDate();
        let newformat = new Date(year, month, day);
        return newformat;
    }

    const getBranchByBusiness = async () => {
        try {
            const response = await BranchOfficeFetchAPI.getBranchOfficesByBusiness(user.business_id, token);
            if (response.data) {

                setBranchDefault(response.data.data.filter(branch => branch?.ecommerce_default == 1));
                setBranches(response.data.data);
            } else {
                setBranches([]);
            }
        } catch (err) {
            setBranches([]);
        }
    }

    const updateBranchDefault = async (branch_id, status) => {
        try {
            await BranchOfficeFetchAPI.updateBranchoffice(branch_id, { ecommerce_default: status }, token);
            setSelectedBranch(branch_id);
            setShowBranchModal(false);
            getBranchByBusiness();
            ErrorAlert('', 'Sucursal predeterminada actualizada', 'success');
        } catch (err) {
            ErrorAlert(err, 'Error al actualizar la sucursal', 'error');
        }
    }

    //Function to get the events
    const getEvents = async (date_id) => {

        try {
            //Get the events by business
            const response = await EventsFetchAPI.getEventsByBusiness(user.business_id, token);
            let formatJsonEventsFront = [];
            response.data.events.forEach(event => {
                event.dates.forEach(date => {
                    let formatEvent = {
                        id: event.id,
                        name: event.name,
                        code: event.code,
                        description: event.description,
                        branches: [],
                        branchMachines: {},
                        date_id: date.event_date_id,
                        code: event.code,
                        start: isoToJsDate(date.initialDate),
                        end: isoToJsDate(date.maxDate),
                        notes: "",
                        state: event.state,

                    }
                    formatJsonEventsFront.push(formatEvent);
                })

            });

            if (date_id) {
                return formatJsonEventsFront.filter(event => event.date_id === date_id);
            }
            setEvents(formatJsonEventsFront);
        } catch (err) {
            setEvents([])
        }
    }

    //Function to create a new event 
    const newEvent = async (e) => {
        e.preventDefault();
        try {
            //We add the business id to the form data
            formData.business_id = user.business_id;

            console.log(formData);
            //Create a new event
            await EventsFetchAPI.createEvent(formData, token);
            //Get the events
            getEvents();
            //Close the modal
            setShowNewEventModal(false);
            //Show the alert
            ErrorAlert('', 'Evento creado', 'success');
            setFormData({});

        } catch (err) {
            ErrorAlert(err, 'Error al crear el evento', "error");
        }
    }

    //Function to add a new date to the event
    const addDateToEvent = async (e) => {
        e.preventDefault();
        try {
            //Create a new date to the event
            await EventsFetchAPI.createEventDate(selectedEvent.id, formData, token);
            //Get the events
            getEvents();
            //Close the modal
            setShowDatesEventModal(false);
            //Show the alert
            ErrorAlert('', 'Fecha agregada', 'success');
            setFormData({});

        } catch (err) {
            ErrorAlert(err, 'Error al agregar la fecha', "error");
        }
    }

    //Function to render the list of events
    const renderEvents = () => {
        const list = events.map(event => (
            <Col sm="2" md="6" lg="3" xl="3" >

                <div
                    className="d-flex justify-content-between align-items-center border rounded-3 p-2"
                >
                    <img
                        className='imgitemsList m-1 border'
                        src={ event.img ? buildCloudinaryImageUrl({ url: event.img, width: 300, quality: "auto", type: "image" }) : defaultImage }
                        loading='lazy'
                        alt=""
                    />
                    <div className="ms-2 me-auto d-inline-block text-truncate">


                        <div className="ms-1 me-auto d-inline-block">
                            <div className="fw-bold text-truncate card-item-categorie-title">{event.name}</div>
                            <p className='text-secondary fw-light text-truncate card-item-categorie-description'>
                                {event.description}
                            </p>
                        </div>


                        <div className='d-flex justify-constent-center align-items-center gap-1'>
                            <div>
                                <ModalDetailEvents
                                    event={event}
                                />
                            </div>
                            {/** Button to create a new date to the event */}
                            <RenderIf isTrue={checkUserPermission('create_date_event', user.permissions) !== -1}>
                                <div onClick={() => (setSelectedEvent(event), setShowDatesEventModal(true))}>
                                    <button className='btn btn-outline-light pulse rounded-3 p-2 lh-1 border' >
                                        <i className="uil uil-calendar-alt text-dark"></i>
                                    </button>
                                </div>
                            </RenderIf>

                        </div>
                    </div>
                </div>
            </Col>

        ))
        return (list)
    }


     const viewBranch = () => {
        const listItems = branches.map((branch, index) => (
            <>
                {/* <div className='m-3'>
                    <div className='btn btn-outline-primary  d-block border border-3 rounded-pill p-3 ' onClick={() => (safeSelect(branch))}>
                        <span className='p-3  text-wrap px-3'>{branch.branchoffice_name}</span>
                    </div>
                </div> */}

                <input type="radio" className="btn-check" name="items-branchs" id={branch.branchofficeName + index} 

                />
                {branch?.ecommerce_default == 0 ?<> <label className="btn-branchs card-title rounded-3  p-2 border border-primary text-center fw-semibold w-100 text-primary" translate='no' role='button'
                    for={branch.branchofficeName + index}
                    onClick={() => updateBranchDefault(branch.branchofficeId, 1)}>
                    <span> {branch.branchofficeName}</span>
                </label></>:<>
                 <label className=" card-title rounded-3  p-2 border border-success text-center fw-semibold w-100 text-success" translate='no' role='button'
                    for={branch.branchofficeName + index}
                    onClick={() => updateBranchDefault(branch.branchofficeId, 0)}>
                    <span> {branch.branchofficeName} (Predeterminado)</span>
                </label></>}
               

            </>
        ));
        return (listItems)
    }

    //Hook to get the events
    useEffect(() => {
        getBranchByBusiness();
        getEvents();
    }, []);

    return (
        <>

            <Navbar titlePage="Eventos" route="new_events" />
            <div className=' bg-light pt-5'>
                <div className='container'>
                    {/** Body header */}
                    <div className='m-2'>
                        <main className="container mt-4">
                            <section className='banner-reports d-flex justify-content-lg-between align-items-center mb-4 banner-sp rounded-4 py-2 px-3'>
                                <div>
                                    <div className='d-flex justify-content-lg-between align-items-center'>
                                        <h2 className='banner-reports-title mb-0 pb-0'>
                                            Eventos
                                        </h2>
                                    </div>
                                    <p className='m-0 p-0 banner-reports-description'>Gestión y creación de eventos.</p>
                                </div>

                                <div className="d-flex align-items-center gap-2 mt-3">
                                    <button
                                        className="btn btn-outline-primary rounded-3"
                                        onClick={() => setShowBranchModal(true)}
                                        type="button"
                                    >
                                         {branchDefault && branchDefault.length > 0 ? <>
                                        <span className="badge bg-success text-white ms-2 px-3 py-2 rounded-pill">
                                            {branchDefault[0].branchofficeName}
                                        </span></> : "Configurar sucursal predeterminada"}
                                    </button>
                                   
                                </div>
                                <Modal show={showBranchModal} onHide={() => setShowBranchModal(false)} centered>
                                    <Modal.Header closeButton>
                                        <Modal.Title>Seleccionar sucursal predeterminada</Modal.Title>
                                    </Modal.Header>
                                    <Modal.Body>

                                        <div className='idioma-sp position-relative '>
                                            <section className="form-signin-sp bg-white border-0">
                                                <h2 className="title-main-login  text-center ">      <i class="uil uil-store-alt"></i>Sucursales</h2>
                                                <div className=' pb-4' >
                                                    <label className="form-label fw-normal text-gray-600">
                                                        Lista de sucursales
                                                    </label>
                                                    <div className='branch-wrapper  no-scroll'>
                                                        <div className='d-flex flex-column gap-3 p-2 bg-body' >
                                                            {viewBranch()}
                                                        </div>
                                                    </div>
                                                    <div className='d-block text-center mt-3 opacity-50'>
                                                        <i class="uil uil-info-circle"></i>
                                                        Escoge  la sucursal de tu preferencia.
                                                    </div>
                                                </div>
                                            </section>
                                            
                                        </div>
                                    </Modal.Body>
                                </Modal>

                                {/* <RenderIf isTrue={checkUserPermission('create_event', user.permissions) !== -1}>
                                    <SmartPayForm
                                        button_text={"Crear evento"}
                                        formType={"addForm"}
                                        buttonModal={true}
                                        modal_header_text={"Crear evento"}
                                        modal_body={modalFields}
                                        initialFormValues={modalFields}
                                        setShowModal={setShowNewEventModal}
                                        showModal={showNewEventModal}
                                        submit={newEvent}
                                        handleFieldChange={handleFieldChange}
                                    />
                                </RenderIf>*/}
                            </section>
                        </main>

                        {/** Main container */}
                        {/* <div className="container">
                            <div className="row  mx-1 mt-3 ">
                                <div className='col-12 col-sm-6 col-md-6 col-lg-6 col-xl-4  p-1 order-0 order-lg-0 order-md-0'>
                                    <div className='d-flex justify-content-lg-between justify-content-md-start justify-content-center'>
                                        <h4 className=' fs-5 fw-bold text-left text-primary'>
                                            Listado de eventos
                                        </h4>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                {renderEvents()}
                            </div>
                        </div> */}
                        <EventCalendar events={events} setEvents={setEvents} formData={formData} newEvent={newEvent} getEvents={getEvents} />
                    </div>
                </div>
            </div>

            {/** Modal to add a new date to the event */}
            <SmartPayForm
                formType={"addForm"}
                buttonModal={false}
                modal_header_text={"Ingrese nueva fecha"}
                modal_body={formDataDates}
                initialFormValues={formData}
                setShowModal={setShowDatesEventModal}
                showModal={showDatesEventModal}
                submit={addDateToEvent}
                handleFieldChange={handleFieldChange}
            />
        </>
    );
}

export default Events;
